import React from "react";
import sponser1 from "../assets/imgs/sponsers/college logo.png";
import "../assets/styles/style.css"; // make sure you have the CSS file

const Sponsers = () => {
  return (
    <section className="sponsers-section scroll-effect">
      <h1>Sponsers</h1>
      <div className="marquee-container">
        <div className="marquee">
          <img src={sponser1} alt="Sponser" />
        </div>
      </div>
    </section>
  );
};

export default Sponsers;
